import { useContext } from "react";
import { experiencesActionTypes } from "../reducer/resume-experiences-reducer";
import { ResumeContext } from "../resume-context";

function useResumeExperiencesHandlers() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleAdd: ( insertionIndex, experienceOrders ) => {
            dispatch( {
                type: experiencesActionTypes.ADD_EXPERIENCE,
                insertionIndex,
                experienceOrders,
                item: {
                    order: -1,
                    from: '',
                    to: '',
                    isCurrent: false,
                    duration: null,
                    jobPosition: null,
                    employer: null,
                    contractType: null,
                    isConsultingMission: false,
                    client: null,
                    location: null,
                    context: null,
                    achievement: null,
                    technicalEnvironments: [],
                    activitySector: null,
                    actions: [],
                    roles: [],
                    numberOfGlobalDays: '',
                    numberOfMissionDays: '',
                },
            } );
        },
        handleChange: ( experience ) => {
            dispatch( {
                type: experiencesActionTypes.CHANGE_EXPERIENCE,
                item: experience,
            } );
        },
        handleRemove: ( experience ) => {
            dispatch( {
                type: experiencesActionTypes.REMOVE_EXPERIENCE,
                item: experience,
            } );
        },
        handleMoveUp: ( experience ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_EXPERIENCE_UP,
                item: experience,
            } );
        },
        handleMoveDown: ( experience ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_EXPERIENCE_DOWN,
                item: experience,
            } );
        },
        handleAddRole: ( parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.ADD_EXPERIENCE_ROLE,
                item: {
                    text: ''
                },
                parentOrder: parentOrder
            } );
        },
        handleChangeRole: ( role, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.CHANGE_EXPERIENCE_ROLE,
                item: role,
                parentOrder: parentOrder
            } );
        },
        handleRemoveRole: ( role, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.REMOVE_EXPERIENCE_ROLE,
                item: role,
                parentOrder: parentOrder
            } );
        },
        handleMoveRoleUp: ( role, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_EXPERIENCE_ROLE_UP,
                item: role,
                parentOrder: parentOrder
            } );
        },
        handleMoveRoleDown: ( role, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_EXPERIENCE_ROLE_DOWN,
                item: role,
                parentOrder: parentOrder
            } );
        },
        handleAddAction: ( parentOrder ) => {
            dispatch(
                {
                    type: experiencesActionTypes.ADD_EXPERIENCE_ACTION,
                    item: {
                        order: -1,
                        text: null
                    },
                    parentOrder: parentOrder
                }
            );
        },
        handleChangeAction: ( action, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.CHANGE_EXPERIENCE_ACTION,
                item: action,
                parentOrder: parentOrder
            } );
        },
        handleRemoveAction: ( action, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.REMOVE_EXPERIENCE_ACTION,
                item: action,
                parentOrder: parentOrder
            } );
        },
        handleMoveActionUp: ( action, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_UP_EXPERIENCE_ACTION,
                item: action,
                parentOrder: parentOrder
            } );
        },
        handleMoveActionDown: ( action, parentOrder ) => {
            dispatch( {
                type: experiencesActionTypes.MOVE_DOWN_EXPERIENCE_ACTION,
                item: action,
                parentOrder: parentOrder
            } );
        },
    }
}

export default useResumeExperiencesHandlers
